import { applyESPNLogic } from './espn-form-handlers';
import { getMatchData } from './get-match-data';

export const applyFieldLogic = (fieldKey: string, value: any, formData: any): Record<string, any> => {
  const updates: Record<string, any> = {};

  // 1. Lógica general ESPN (time sync, sport change)
  Object.assign(updates, applyESPNLogic(fieldKey, value, formData));

  // 2. Autocompletar datos del partido cuando se selecciona team2
  if (fieldKey === 'team2' && value) {
    const creativityType = formData._creativityType;
    const matchData = getMatchData({ ...formData, team2: value }, creativityType);

    if (matchData) {
      const fieldsToAutoComplete = [
        'date',
        'day',
        'region1',
        'region2',
        'region3',
        'region4',
        'time1',
        'time2',
        'time3',
        'time4'
      ] as const;

      fieldsToAutoComplete.forEach(field => {
        const fieldValue = matchData[field as keyof typeof matchData];
        if (!formData[field] && fieldValue) {
          updates[field] = fieldValue;
        }
      });
    }
  }

  return updates;
};
